// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__GRaLN","rootCenter":"LoadMoreObserver_rootCenter__27VoE","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1DD1U"};